module.exports = __webpack_public_path__ + "static/media/ic_suspend_trial.5f378c56.svg";